export default __webpack_public_path__ + "static/media/title-quoteIcon.d6791a31.svg";